import React from 'react';
import {
  DesktopOutlined,
  TabletOutlined,
  MobileOutlined
} from '@ant-design/icons';
import SiteBuilderModel from '../../model/SiteBuilderModel';
import { DESKTOP, TABLET, MOBILE } from '../../consts/devices';
import Logo from '../../../../../frontend/assets/reeach-Logo.svg';
import { BodyText } from '../../../../components/ui/Typography';

const devices = [
  { key: DESKTOP, label: 'Desktop', icon: <DesktopOutlined /> },
  { key: TABLET, label: 'Tablet', icon: <TabletOutlined /> },
  { key: MOBILE, label: 'Mobile', icon: <MobileOutlined /> }
];

const PreviewHeader: React.FC = () => {
  return (
    <div className="flex items-center w-full bg-white">
      <div className="flex items-center">
        <div className="logo-holder hidden md:flex justify-center w-[86px] py-[12px] border-l border-r border-solid border-[rgba(0,0,0,0.15)] border border-t-0 border-b-0">
          <img src={Logo} alt="Logo" />
        </div>

        <BodyText className="font-bold ml-[24px]" style={{ marginBottom: '0', lineHeight: '23px', color: '#000000A6' }}>Preview-Editor</BodyText>
      </div>
      <div className="flex-1" />
      <div className="hidden 2xl:flex items-center h-full">
        {devices.map((device) => {
          const selected =
            SiteBuilderModel.currentSelectedDevice === device.key;
          const color = selected ? '#fff' : 'rgba(0,0,0,0.45)';
          return (
            <button
              key={device.key}
              className={`flex items-center px-[16px] cursor-pointer transition-colors border-none  font-bold ${
                selected
                  ? 'bg-[#3498db] shadow-sm'
                  : 'bg-transparent hover:bg-gray-100'
              }`}
              style={{ height: '100%' }}
              onClick={() =>
                SiteBuilderModel.setCurrentSelectedDevice(device.key)
              }>
              <BodyText style={{ marginBottom: 0, color , lineHeight: '23px' }}>
                {device.label}
              </BodyText>
              <span style={{ color, marginLeft: '10px' }}>{device.icon}</span>
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default PreviewHeader;
